import InfoIcon from 'Components/Icons/InfoIcon';
import { Context } from 'Context/Context';
import { getNoOfTimesRequested } from 'Utils';
import React, { useContext, useEffect, useState } from 'react'

function DeniedInfo({reqRevCountArr, detail}) {
    
    const {userDetails} = useContext(Context);
    const [seeIfreqRevCountArr, setSeeIfreqRevCountArr] = useState(null);
    useEffect(() => {
      
      setSeeIfreqRevCountArr(reqRevCountArr?.[detail?._id]?.denied);
    }, [reqRevCountArr]);
  return (
  <>
  {seeIfreqRevCountArr ?
        <div className='bg-yellow-100 text-xs mb-4 flex justify-center items-center p-1 w-max rounded'>
            <InfoIcon/>
            &nbsp;You have requested to view this case {seeIfreqRevCountArr} {seeIfreqRevCountArr === 1 ? "time" : "times"} before</div>
            :
            ''
        }
  </>
    
  )
}

export default DeniedInfo